import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { get } from '@cullylarson/f';
import { preventDefault } from '@@client/lib/events';
import FormEmail from '@@client/components/FormEmail';
import FormText from '@@client/components/FormText';
export default function NewsletterForm(props) {
  var _useState = useState(get('email', '', props)),
      email = _useState[0],
      setEmail = _useState[1];

  var _useState2 = useState(get('name', '', props)),
      name = _useState2[0],
      setName = _useState2[1];

  var disabled = get('disabled', false, props);
  var buttonTitle = get('buttonTitle', 'Sign Up', props);
  var idPrefix = get('idPrefix', 'newsletter', props);
  var paramErrors = get('paramErrors', {}, props);
  var onSubmit = get('onSubmit', function () {}, props);
  var includeLabels = get('includeLabels', false, props);

  var handleParam = function handleParam(setValue) {
    return function (e) {
      return e && e.target ? setValue(e.target.value) : setValue(e);
    };
  };

  var handleSubmit = preventDefault(function () {
    onSubmit({
      email: email,
      name: name
    });
  });
  return /*#__PURE__*/_jsxs("form", {
    onSubmit: handleSubmit,
    children: [/*#__PURE__*/_jsx(FormText, {
      idPrefix: idPrefix,
      name: "name",
      "aria-label": includeLabels ? undefined : 'Your Name',
      title: includeLabels ? 'Your Name' : undefined,
      placeholder: includeLabels ? undefined : 'Your Name',
      value: name,
      onChange: handleParam(setName),
      errors: get('name', [], paramErrors),
      autoComplete: "name"
    }), /*#__PURE__*/_jsx(FormEmail, {
      idPrefix: idPrefix,
      name: "email",
      "aria-label": includeLabels ? undefined : 'Email Address',
      title: includeLabels ? 'Email Address' : undefined,
      placeholder: includeLabels ? undefined : 'Email Address',
      value: email,
      onChange: handleParam(setEmail),
      errors: get('email', [], paramErrors),
      autoComplete: "email"
    }), /*#__PURE__*/_jsx("div", {
      className: "actions",
      children: /*#__PURE__*/_jsx("button", {
        className: "btn btn--blue--light",
        type: "submit",
        disabled: disabled,
        children: buttonTitle
      })
    })]
  });
}